export default {
  picsArrImg: {
    0: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观X/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观X/2.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观X/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观X/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观X/5.jpg")
      }
    ],
    1: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/新辉昂/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/新辉昂/2.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/新辉昂/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/新辉昂/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/新辉昂/5.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/新辉昂/6.jpg")
      }
    ],
    2: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/2.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/5.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/6.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途昂X极夜限定版/7.jpg")
      },
    ],
    3: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/威然Viloran/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/威然Viloran/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/威然Viloran/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/威然Viloran/5.jpg")
      },
    ],
    4: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观L PHEV/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观L PHEV/2.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观L PHEV/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观L PHEV/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/途观L PHEV/5.jpg")
      },
    ],
    5: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/帕萨特 PHEV/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/帕萨特 PHEV/2.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/帕萨特 PHEV/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/帕萨特 PHEV/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/帕萨特 PHEV/5.jpg")
      },
    ],
    6: [
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/柯珞克/1.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/柯珞克/2.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/柯珞克/3.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/柯珞克/4.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/柯珞克/5.jpg")
      },
      {
        type: 1,
        url: require("../../assets/exhibition-bj/轮播/柯珞克/6.jpg")
      },
    ],
  }
}
